import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

import { updateDlCustomsClearanceRequestAPI } from '../customs-clearance-request/api';

import {
  getGenerallistAPI,
  getPortlistAPI,
  getStatuslistAPI,
  getEntityInfoAPI,
  getUserInfoAPI,
  getGeneraDropListOfficeAPI,
  getUserGrpListAPI,
  getSignedUrlAPI,
  compressFileDownloadAPI,
} from './api';
import {
  getEntityList,
  getEntityListSuccess,
  getGeneralDropListOffice,
  getGeneralDropListOfficeSuccess,
  getGeneralList,
  getGeneralListSuccess,
  getPODList,
  getPODListSuccess,
  getPOLList,
  getPOLListSuccess,
  getStatusList,
  getStatusListSuccess,
  getUserInfor,
  getUserSuccess,
  getUserGrpList,
  getUserGrpListSuccess,
  getSignedUrlSuccess,
  getSignedUrl,
  compressFileDownload,
  compressFileDownloadSuccess,
  compressFileDownloadFailure,
  getSignedUrlFailure,
} from './slice';

function* getGeneralListSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getGenerallistAPI, payload);
    yield put(getGeneralListSuccess({ response, type: payload.type }));
  } catch (error) {
    console.log(error);
  }
}

function* getPODListSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getPortlistAPI, payload);
    yield put(getPODListSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getPOLListSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getPortlistAPI, payload);
    yield put(getPOLListSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getStatusListSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getStatuslistAPI, payload);
    yield put(getStatusListSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getEntityInforListSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getEntityInfoAPI, payload);
    yield put(getEntityListSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getUserInfoSaga() {
  try {
    const response: ResponseGenerator = yield call(getUserInfoAPI);
    yield put(getUserSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getGeneraDropListOfficeSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getGeneraDropListOfficeAPI, payload);
    yield put(getGeneralDropListOfficeSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getUserGrpListSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getUserGrpListAPI, payload);
    yield put(getUserGrpListSuccess(response));
  } catch (error) {
    console.log(error);
  }
}

function* getSignedUrlSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getSignedUrlAPI, payload);
    yield put(getSignedUrlSuccess(response));
  } catch (error) {
    yield put(getSignedUrlFailure({ loading: false }));
    console.log(error);
  }
}

function* compressFileDownloadSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(compressFileDownloadAPI, { params: payload });
    if (response.results.code === 9) {
      yield put(compressFileDownloadFailure({ message: response.results.message, loading: false }));
    } else {
      if (payload.dlCustNo && payload.dlCustNo.length > 0)
        yield call(updateDlCustomsClearanceRequestAPI, payload.dlCustNo);
      yield put(compressFileDownloadSuccess(response));
    }
  } catch (error) {
    yield put(compressFileDownloadFailure({ loading: false }));
  }
}

function* watchCommon() {
  yield takeEvery(getGeneralList, getGeneralListSaga);
  yield takeLatest(getPODList, getPODListSaga);
  yield takeLatest(getPOLList, getPOLListSaga);
  yield takeLatest(getStatusList, getStatusListSaga);
  yield takeLatest(getEntityList, getEntityInforListSaga);
  yield takeLatest(getUserInfor, getUserInfoSaga);
  yield takeLatest(getGeneralDropListOffice, getGeneraDropListOfficeSaga);
  yield takeLatest(getUserGrpList, getUserGrpListSaga);
  yield takeLatest(getSignedUrl, getSignedUrlSaga);
  yield takeLatest(compressFileDownload, compressFileDownloadSaga);
}

export default watchCommon;
